import { useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';
import Tabs from "@imminently/decisively-ui/Tabs";

import { Roles, useAuthorise } from '@/auth/permissions';

import { useRouting } from '@/hooks/use-routing';
import Icon from "@imminently/decisively-ui/Icon";

export const Navigation = () => {
  const { goToPage } = useRouting();
  const match = useRouteMatch();
  const authorise = useAuthorise();
  const { t } = useTranslation();

  const tabs = [
    {
      value: 'projects',
      name: t('projects_label'),
      icon: <Icon name="projects" />,
      route: /^\/projects.*$/,
      onClick: () => goToPage('/projects'),
    },
    {
      value: 'build',
      name: t("build_label"),
      icon: <Icon name="build" />,
      route: /^\/(build|models).*$/,
      onClick: () => goToPage('/build'),
      role: [Roles.ProjectReader, Roles.ProjectWriter, Roles.ProjectTechnical],
    },
    {
      value: 'verify',
      name: t("verify_label"),
      icon: <Icon name="testing" />,
      route: /^\/verify.*$/,
      onClick: () => goToPage('/verify'),
      role: Roles.Tester,
    },
    {
      value: 'monitor',
      name: t("monitor_label"),
      icon: <Icon name="monitor-icon" />,
      route: /^\/(monitor).*$/,
      onClick: () => goToPage('/monitor/overview'),
      role: Roles.ReportViewer,
    },
  ].filter(t => t.role ? authorise(t.role) : true);

  const activeTab = tabs.find(t => t.route.test(match.url));
  // fallback to undefined, no tab, if the url doesn't match any tab (e.g. on /admin)
  const value = activeTab?.value || undefined;

  return (
    <Tabs intent={"bare"} value={value} className="min-h-10 h-full items-end flex overflow-visible">
      <Tabs.List className="h-full bg-transparent border-0! relative">
        {tabs.map(tab => (
          <Tabs.Trigger
            key={`nav-${tab.value}`}
            value={tab.value}
            onClick={tab.onClick}
            className="min-w-25 h-full text-sidebar-foreground font-semibold text-base leading-6 px-6 flex items-center gap-2 data-[state=active]:text-sidebar-primary! transition-colors relative after:absolute after:bottom-0 after:left-0 after:right-0 after:h-1 after:bg-sidebar-primary! after:rounded-t-2xl after:opacity-0 data-[state=active]:after:opacity-100 after:transition-opacity"
          >
            {tab.icon}
            <span>{tab.name}</span>
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs>
  );
};